import { React, StrictMode } from "react";
import ReactDOM from "react-dom/client";// Note the change to "react-dom/client"
import App from "./App";
import ZohoWidgetLoader from "./components/ZohoWidgetLoader";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { legacy_createStore as createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import reducer from "./store";
import rootSaga from "./sagas";
import {FeatureFlagProvider} from "./context/FeatureFlagContext";

const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Creamos el store aplicando el middleware y, si está presente, el enhancer de DevTools.
const store = createStore(
  reducer,
  composeEnhancers(
    applyMiddleware(sagaMiddleware)
  )
);
sagaMiddleware.run(rootSaga);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(

  <StrictMode>
    <Provider store={store}>
      <ZohoWidgetLoader loadWhen={() => !window.location.pathname.startsWith("/payments")} />
      <FeatureFlagProvider refetchInterval={60000} >
        <App />
      </FeatureFlagProvider>
    </Provider>
  </StrictMode>
);

reportWebVitals();
